import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Drawer } from "antd";
import { useAppContext } from "utils/context";

import {
  createUserAddress,
  getCitiesData,
  getProvincesData,
} from "containers/services/services";

import {
  handleAddressData,
  provinceDataTransformer,
} from "containers/services/data.transformers";

import AddressFrom from "./address";
import EmailFrom from "./email";
import Information from "./information";

export const INFORMATION_STATUES = {
  ADDRESS: "address",
  EMAIL: "email",
  INFO: "info",
};

export default function ContractDrawer({
  // formRef,
  addressData,
  loadingOTP,
  open,
  onClose,
  onSendOTP,
  onUpdateAddressData,
}) {
  const { t } = useTranslation();
  const { instance } = useAppContext();
  const [mode, setMode] = useState(INFORMATION_STATUES.INFO);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [loadingAddress, setLoadingAddress] = useState(false);

  const onFinishAddAddress = async (values) => {
    setLoadingAddress(true);

    const { data } = await createUserAddress(
      instance,
      handleAddressData(values)
    );

    if (data) onUpdateAddressData({ ...addressData, ...data });

    handleChangedMode(INFORMATION_STATUES.INFO);
    setLoadingAddress(false);
  };

  const onFinishEmail = async (values) => {
    onUpdateAddressData({
      ...addressData,
      email_address: values?.email_address,
    });
    handleChangedMode(INFORMATION_STATUES.INFO);
  };

  const handleChangedMode = (current) => setMode(current);

  const getProvinces = useCallback(async () => {
    const response = await getProvincesData(instance);
    if (response) {
      setProvinces(response?.data);
    }
  }, [instance]);

  const getCities = async (e) => {
    const response = await getCitiesData(instance, e);
    if (response) {
      setCities(response?.cities);
    }
  };

  useEffect(() => {
    getProvinces();
  }, [getProvinces]);

  const renderStates = () => {
    switch (mode) {
      case INFORMATION_STATUES.ADDRESS:
        return (
          <AddressFrom
            cities={provinceDataTransformer(cities)}
            loading={loadingAddress}
            getCities={getCities}
            provinces={provinceDataTransformer(provinces)}
            values={addressData}
            onFinish={onFinishAddAddress}
          />
        );

      case INFORMATION_STATUES.EMAIL:
        return <EmailFrom values={addressData} onFinish={onFinishEmail} />;

      case INFORMATION_STATUES.INFO:
      default:
        return (
          <Information
            loadingOTP={loadingOTP}
            userInfo={addressData}
            onChangedMode={handleChangedMode}
            onSendOTP={onSendOTP}
          />
        );
    }
  };

  const renderTitle = () => {
    switch (mode) {
      case INFORMATION_STATUES.ADDRESS:
        return t("pma-onboarding.edit-address");

      case INFORMATION_STATUES.EMAIL:
        return t("pma-onboarding.edit-email");

      case INFORMATION_STATUES.INFO:
      default:
        return t("pma-onboarding.confirm-information");
    }
  };
  const handleCloseEditMode = () => {
    if ([INFORMATION_STATUES.EMAIL, INFORMATION_STATUES.ADDRESS].includes(mode))
      return handleChangedMode(INFORMATION_STATUES.INFO);

    return onClose();
  };

  return (
    <Drawer
      closable
      destroyOnClose
      key="bottom"
      open={open}
      title={renderTitle()}
      placement={window.innerWidth < 768 ? "bottom" : "left"}
      onClose={handleCloseEditMode}
    >
      {renderStates()}
    </Drawer>
  );
}
